import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/expense-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IExpense } from 'src/types/expense';
import ExpenseActionsColumn from './ExpenseActionsColumn';
import { CellProps } from 'react-table';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import GeneralEnumService from '../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import dateFilterMulti from '../../../../../../../components/react-table/filters/date-filter-multi';
import { ICase } from '../../../../../../../types/case';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IExpense>;
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    providers: SelectObject[];
}

const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('ExpenseStatus') : {};
const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
const getColumns = (dataProd: SelectObject[]): Column<IExpense>[] => [
    {
        Header: 'Date',
        disableSortBy: true,
        accessor: 'expenseDate',
        headerClassName: 'text-center w-100 d-block',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IExpense>) => {
            return (
                <div className={'text-center'}>
                    {original.expenseDate ? changeToZeroMoment(original.expenseDate, 'MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilterMulti<IExpense>(),
    },
    {
        Header: 'Provider',
        disableSortBy: true,
        accessor: 'provider.id',
        Filter: dropdownFilter<IExpense>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IExpense>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
    },
    {
        Header: 'Sum',
        disableSortBy: true,
        accessor: 'amount',
        Filter: textFilter<IExpense>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IExpense>) => {
            return original.amount ? `$${numberWithCommas(original.amount)}` : null;
        },

        disableFilters: true,
    },
    {
        Header: 'Description',
        accessor: 'description',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IExpense>(),
    },
    {
        Header: 'Note',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'note',
        Filter: textFilter<IExpense>(),
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseStatus = statusItems.find((it) => it.value === original.status);
            return valueCaseStatus ? valueCaseStatus.label : '';
        },
        Filter: dropdownFilter<IExpense>(statusItems),
    },

    {
        Header: 'Actions',
        accessor: 'id',
        Cell: ExpenseActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const ExpensesGrid: React.FunctionComponent<Props> = ({ data, getData, providers, getDataCsv }: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers));
    }

    return (
        <div className={classNames(styles.grid)}>
            <Grid<IExpense> columns={columns} getDataCsv={getDataCsv} data={data} getData={getData} />
        </div>
    );
};

export default ExpensesGrid;
